export function createGradientArray(startColor, endColor, numColors) {
    if (startColor && endColor) {
        var gradientArray = []
        var startRGB = hexToRGB(startColor)
        var endRGB = hexToRGB(endColor)

        var rIncrement = (endRGB.r - startRGB.r) / (numColors - 1)
        var gIncrement = (endRGB.g - startRGB.g) / (numColors - 1)
        var bIncrement = (endRGB.b - startRGB.b) / (numColors - 1)

        for (var i = 0; i < numColors; i++) {
            var r = Math.round(startRGB.r + rIncrement * i)
            var g = Math.round(startRGB.g + gIncrement * i)
            var b = Math.round(startRGB.b + bIncrement * i)

            const hexColor = `rgb(${r}, ${g}, ${b})`
            gradientArray.push(hexColor)
        }

        return gradientArray
    }
}

function hexToRGB(hex) {
    if (hex) {
        var r = parseInt(hex.substr(1, 2), 16)
        var g = parseInt(hex.substr(3, 2), 16)
        var b = parseInt(hex.substr(5, 2), 16)

        return { r, g, b }
    }
}

function RGBToHex(r, g, b) {
    var hexR = r.toString(16).padStart(2, '0')
    var hexG = g.toString(16).padStart(2, '0')
    var hexB = b.toString(16).padStart(2, '0')

    return '#' + hexR + hexG + hexB
}

export function maxPossibleColorsOnGradient(startColor, endColor) {
    if (startColor && endColor) {
        const startRGB = hexToRGB(startColor)
        const endRGB = hexToRGB(endColor)

        const rDifference = Math.abs(endRGB.r - startRGB.r)
        const gDifference = Math.abs(endRGB.g - startRGB.g)
        const bDifference = Math.abs(endRGB.b - startRGB.b)

        const minDifference = Math.min(rDifference, gDifference, bDifference)

        // Adding 1 to include both the start and end colors in the count
        return minDifference + 1
    }
}
